import apiClient from './api';

export function getPermBookingByMemberPhone(phone) {
  return apiClient.post('/member/getPermBookingByMemberPhone', { phone });
}
